const ASYNC_TASK_IN_PROGRESS_STATUSES = new Set([
  'initializing',
  'starting run',
  'initialize success',
  'waiting',
  'running',
])

export function isAsyncTaskInProgressStatus(status) {
  return ASYNC_TASK_IN_PROGRESS_STATUSES.has(String(status || '').trim().toLowerCase())
}

export function isAsyncTaskInProgress(task) {
  return isAsyncTaskInProgressStatus(task?.status)
}

export function hasInProgressAsyncTasks(tasks) {
  return Array.isArray(tasks) && tasks.some(isAsyncTaskInProgress)
}
